/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Slug_HintInputs */

const cs_settings_venues_slug_hint = /** @type {(inputs: Settings_Venues_Slug_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malá písmena, číslice a pomlčky. Používá se v URL a exportech.`)
};

const en_settings_venues_slug_hint = /** @type {(inputs: Settings_Venues_Slug_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lowercase letters, digits and hyphens. Used in URLs and exports.`)
};

/**
* | output |
* | --- |
* | "Lowercase letters, digits and hyphens. Used in URLs and exports." |
*
* @param {Settings_Venues_Slug_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_slug_hint = /** @type {((inputs?: Settings_Venues_Slug_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Slug_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_slug_hint(inputs)
	return cs_settings_venues_slug_hint(inputs)
});